<template>
  <div id="featureOverviewCardRootCardRoot">
    <div id="imageContainer">
      <JulioIcon :transition-type="'fill'" :style="iconTranslate" id="julioImage"/>
      <div :style="titleOpacity" class="h1" id="title"><span>4.1</span></div>
    </div>

    <div id="featureOverviewRoot" :style="iconOpacity">
      <div id="overviewContainer">
        <div id="overViewTitle"><span v-html="name"></span></div>
        <div id="tagline" class="h2"><span v-html="tagline"></span></div>
        <div id="description"><p v-html="taglineDescription"></p></div>
      </div>
    </div>
  </div>
</template>

<script>
import JulioIcon from "../icons/JulioIcon";

export default {
  name: "FeatureOverviewCard",
  components: {JulioIcon},
  props: {
    height: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ""
    },
    taglineDescription: {
      type: String,
      default: ""
    },
    tagline: {
      type: String,
      default: ""
    },
  },
  computed: {
    feature() {
      return this.$store.state.features[0];
    },
    offset() {
      return this.$store.state.scrollOffset
    },
    iconTranslate() {
      if (this.offset > 0) {
        let position = this.offset * 0.4;
        return {
          transform: `translateY(${position}%) !important`,
          '-moz-transform': `translateY(${position}%) !important`,
          '-ms-transform': `translateY(${position}%) !important`,
          '-o-transform': `translateY(${position}%) !important`,
          '-webkit-transform': `translateY(${position}%) !important`
        }
      } else {
        return {
          transform: `translateY(-150)px)`
        }
      }
    },
    iconOpacity() {
      if (this.offset > (this.height * 0.1)) {
        return {
          opacity: '100%',
          transition: `0.2s ease-out !important`,
          '-webkit-transition': `0.2s ease-out !important`,
          '-o-transition': `0.2s ease-out !important`,
          '-moz-transition': `0.2s ease-out !important`
        }
      } else {
        return {
          opacity: '0',
          transition: `0.2s ease-out !important`,
          '-webkit-transition': `0.2s ease-out !important`,
          '-o-transition': `0.2s ease-out !important`,
          '-moz-transition': `0.2s ease-out !important`
        }
      }
    },
    titleOpacity() {
      if (this.offset > 20) return {opacity: `0%`}
      else return {opacity: `100%`}
    }
  },
}
</script>

<style lang="scss" src="../../styles/featureoverviewcard.scss" scoped></style>
